import React from "react";
import {Switch, Route} from 'react-router-dom';
import { ROUTE_ADMIN_MODELS, ROUTE_ADMIN_BRANDS, ROUTE_ADMIN_CAMPAIGN, ROUTE_ADMIN_FILE_MANAGEMENT, ROUTE_ADMIN_WORKSHOPS, ROUTE_CONTRACT_DATA, ROUTE_ENTRY_CHANNEL, ROUTE_EXCEPTIONS, ROUTE_EXTERNAL_USERS, ROUTE_INTERACTION, ROUTE_MAIL_MAPPERS, ROUTE_STATES, ROUTE_SUBSTATES, ROUTE_TAXONOMIES, ROUTE_TEMPLATES, ROUTE_USERS } from "../routes/routesConstants";
import StatesManagement from "./StatesManagement";
import EntryChannelManagement from "./EntryChannelManagement";
import InteractionManagement from "./InteractionManagement";
import TaxonomyManagement from "./TaxonomyManagement";
import UserManagement from "./UserManagement";
import { SubStatesManagement } from "./SubStatesManagement";
import ExceptionManagement from "./ExceptionsManagement";
import ContractDataManager from "./ContractDataManagement";
import TemplatesManagement from "./TemplatesManagement";
import {ExternalUserManagement} from "./ExternalUserManagement";
import WorkshopManagement from "./WorkshopManagement";
import { FileManagement } from "./FileManagement";
import { CampaignManagement } from "./campaigns/CampaignManagemente";
import { PrivateRoute } from "./PrivateRoute";
import { ADMIN, MANAGER } from "../../Constantes/userRoles";
import MailMapperManager from "./MailMapperManagement";
import BrandManagement from "./BrandManagement";
import BrandModelManagement from "./BrandModelManagement"

const AdminWrapper = () => {
    return(
        <div style={{ marginTop: "25px" }}>                       
            <Switch>           
                <PrivateRoute allowedRoles={[ADMIN]}  path={ROUTE_STATES} component={StatesManagement}/>
                <PrivateRoute allowedRoles={[ADMIN]}  path={ROUTE_SUBSTATES}  component={SubStatesManagement}/>
                <PrivateRoute allowedRoles={[ADMIN]}  path = {ROUTE_ENTRY_CHANNEL} component = { EntryChannelManagement }/>
                <PrivateRoute allowedRoles={[ADMIN]}  path = {ROUTE_INTERACTION} component = { InteractionManagement }/>
                <PrivateRoute allowedRoles={[ADMIN]}  path = {ROUTE_TAXONOMIES} component = { TaxonomyManagement } />
                <PrivateRoute allowedRoles={[ADMIN]}  path = {ROUTE_USERS} component = { UserManagement } />
                <PrivateRoute allowedRoles={[ADMIN]}  path = {ROUTE_EXCEPTIONS} component = {ExceptionManagement}/>
                <PrivateRoute allowedRoles={[ADMIN]}  path = {ROUTE_CONTRACT_DATA} component = {ContractDataManager}/>
                <PrivateRoute allowedRoles={[ADMIN]}  path={ROUTE_TEMPLATES} component = {TemplatesManagement}/>
                <PrivateRoute allowedRoles={[ADMIN]}  path={ROUTE_EXTERNAL_USERS} component = {ExternalUserManagement}/>
                <PrivateRoute allowedRoles={[ADMIN]}  path={ROUTE_ADMIN_WORKSHOPS} component = {WorkshopManagement}/>
                <PrivateRoute allowedRoles={[ADMIN]}  path={ROUTE_ADMIN_FILE_MANAGEMENT} component = {FileManagement}/>
                <PrivateRoute allowedRoles={[ADMIN, MANAGER]}  path={ROUTE_ADMIN_CAMPAIGN} component = {CampaignManagement}/>
                <PrivateRoute allowedRoles={[ADMIN]} path={ROUTE_MAIL_MAPPERS} component = {MailMapperManager}/>
                <PrivateRoute allowedRoles={[ADMIN]} path={ROUTE_ADMIN_BRANDS} component = {BrandManagement}/>
                <PrivateRoute allowedRoles={[ADMIN]} path={ROUTE_ADMIN_MODELS} component = {BrandModelManagement}/>
            </Switch>            
        </div>
    )
}

export { AdminWrapper }